<template>
  <transition name="update-notif">
    <div v-if="show" class="update-notification">
      <div class="update-notification__header">
        <span class="fs-18 fw-700" style="color: #2F2F2F;">New Update Available</span>
        <i class="material-icons update-notification__close cursor-pointer" @click="$emit('dismiss')">close</i>
      </div>

      <div class="update-notification__body">
        <div
          v-for="(item, index) in changelogItems"
          :key="index"
          class="update-notification__item"
        >
          <i class="material-icons update-notification__item-icon">{{ item.icon }}</i>
          <span class="fs-14 fw-400" style="color: #4A4A4A; line-height: 1.5;">{{ item.text }}</span>
        </div>
      </div>

      <div class="update-notification__footer">
        <button class="update-notification__btn" @click="$emit('update')">
          Update Now
        </button>
        <span
          class="fs-13 fw-400 cursor-pointer update-notification__later"
          @click="$emit('dismiss')"
        >
          Later
        </span>
      </div>
    </div>
  </transition>
</template>

<script>
import changelog from '@/changelog.json'

export default {
  name: 'UpdateNotification',
  props: {
    show: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    changelogItems() {
      return changelog.items || []
    }
  }
}
</script>

<style scoped lang="scss">
.update-notification {
  position: fixed;
  bottom: 24px;
  left: 24px;
  width: 360px;
  background: #ffffff;
  border: 1px solid #E5E7EB;
  border-radius: 12px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08);
  z-index: 9999;
  overflow: hidden;
  font-family: 'Lato', 'Kanit', sans-serif;
}

.update-notification__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px 24px 16px;
  border-bottom: 1px solid #F0F0F0;
}

.update-notification__close {
  color: #9A9A9A;
  font-size: 18px;
  transition: color 0.15s;

  &:hover {
    color: #4A4A4A;
  }
}

.update-notification__body {
  padding: 16px 24px;
}

.update-notification__item {
  display: flex;
  align-items: flex-start;
  padding: 8px 0;
}

.update-notification__item-icon {
  color: #6C30CC;
  font-size: 20px;
  margin-right: 12px;
  margin-top: 1px;
  flex-shrink: 0;
}

.update-notification__footer {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 8px 24px 20px;
  gap: 12px;
}

.update-notification__btn {
  width: 100%;
  padding: 12px 0;
  background-color: #6C30CC;
  color: #ffffff;
  border: none;
  border-radius: 8px;
  font-family: 'Lato', 'Kanit', sans-serif;
  font-size: 14px;
  font-weight: 700;
  cursor: pointer;
  transition: background-color 0.15s;

  &:hover {
    background-color: #5A27AB;
  }

  &:active {
    background-color: #4E2196;
  }
}

.update-notification__later {
  color: #9A9A9A;
  transition: color 0.15s;

  &:hover {
    color: #6C30CC;
  }
}

// Transition: slide up + fade
.update-notif-enter-active {
  transition: all 0.4s ease-out;
}
.update-notif-leave-active {
  transition: all 0.25s ease-in;
}
.update-notif-enter,
.update-notif-leave-to {
  transform: translateY(20px);
  opacity: 0;
}
</style>
